import { render, staticRenderFns } from "./DeleteKeyModal.vue?vue&type=template&id=228612af&scoped=true"
import script from "./DeleteKeyModal.vue?vue&type=script&lang=js"
export * from "./DeleteKeyModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteKeyModal.vue?vue&type=style&index=0&id=228612af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228612af",
  null
  
)

export default component.exports